import { IProgress } from ".";

interface IProps {
    data: IProgress
}

const Process = (props: IProps) => {
    return (
        <div style={{ padding: 20 }}>
            <div style={{ marginBottom: 20 }}>Progress...</div>

            <table>
                <tbody>
                    <tr>
                        <td style={{ paddingRight: 10 }}>Rows processed:</td>
                        <td>{props.data.rowsProcessed}</td>
                    </tr>

                    <tr>
                        <td style={{ paddingRight: 10 }}>Rows added:</td>
                        <td>{props.data.rowsAdded}</td>
                    </tr>

                    <tr>
                        <td style={{ paddingRight: 10 }}>Rows updated:</td>
                        <td>{props.data.rowsUpdated}</td>
                    </tr>

                    <tr>
                        <td style={{ paddingRight: 10 }}>Rows skipped:</td>
                        <td>{props.data.rowsSkipped}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default Process;